import {Accordion} from '@mantine/core';
import {Box} from 'src/design/atoms/Box';
import {useMediaQuery} from '@mantine/hooks';
import React from 'react';
import type {NotificationSimpleResponse} from 'src/api/ProactApiClient';
import {NoItemsPanel} from 'src/design/molecules/NoItemsPanel';
import {Paginator} from 'src/design/organisms/Pagination';
import {TableBodyRender} from 'src/design/molecules/TableBodyRender';
import {isValidArray} from 'src/utilities/objectUtils';
import {NotificationsListRow} from './NotificationsListRow';

export interface NotificationsListProps {
  data: NotificationSimpleResponse[];
  currentPage: number;
  totalRecords: number;
  recordsPerPage?: number;
  isLoading: boolean;
  noDataText?: string;
  onPageChange?: (event: React.ChangeEvent<unknown>, page: number) => void;
}
export const NotificationsList = ({
  data,
  currentPage,
  totalRecords,
  recordsPerPage = 10,
  noDataText,
  onPageChange,
  isLoading,
}: NotificationsListProps) => {
  const isSmUp = useMediaQuery('(min-width: 600px)');

  return (
    <Box style={{width: '100%', marginBottom: isSmUp ? '2rem' : '0rem'}}>
      {isLoading ? (
        <TableBodyRender isLoading={isLoading} hasData={isValidArray(data)} />
      ) : (
        <>
          <Accordion>
            {data.map(row => (
              <NotificationsListRow key={row.id} data={row} />
            ))}
          </Accordion>
          <Paginator
            mt={24}
            perPage={recordsPerPage}
            currentPage={currentPage}
            totalRecords={totalRecords}
            onChange={onPageChange}
          />
        </>
      )}

      {data.length === 0 && !isValidArray(data) && !isLoading && (
        <NoItemsPanel noItemsText={noDataText} canCreate={false} />
      )}
    </Box>
  );
};
